/**
 * @generated SignedSource<<22898405e6b112f574c085ab4f091f94>>
 * @relayHash 2360d3dcc26f599210be5c95e0fc5db7
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2360d3dcc26f599210be5c95e0fc5db7

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteEpisodesOfCareInput = {
  ids: ReadonlyArray<string>;
};
export type chDeleteEpisodesOfCareMutation$variables = {
  connections: ReadonlyArray<string>;
  input: Ch_deleteEpisodesOfCareInput;
};
export type chDeleteEpisodesOfCareMutation$data = {
  readonly deleteEpisodesOfCare: {
    readonly ch_EpisodeOfCare: ReadonlyArray<{
      readonly id: string;
    }> | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type chDeleteEpisodesOfCareMutation = {
  response: chDeleteEpisodesOfCareMutation$data;
  variables: chDeleteEpisodesOfCareMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chDeleteEpisodesOfCareMutation",
    "selections": [
      {
        "alias": "deleteEpisodesOfCare",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_deleteEpisodesOfCarePayload",
        "kind": "LinkedField",
        "name": "ch_deleteEpisodesOfCare",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_EpisodeOfCare",
            "kind": "LinkedField",
            "name": "ch_EpisodeOfCare",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chDeleteEpisodesOfCareMutation",
    "selections": [
      {
        "alias": "deleteEpisodesOfCare",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_deleteEpisodesOfCarePayload",
        "kind": "LinkedField",
        "name": "ch_deleteEpisodesOfCare",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_EpisodeOfCare",
            "kind": "LinkedField",
            "name": "ch_EpisodeOfCare",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "2360d3dcc26f599210be5c95e0fc5db7",
    "metadata": {},
    "name": "chDeleteEpisodesOfCareMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "2eb2cef90526f3bec465843d17259b0d";

export default node;
